export enum EExamInfoMenuItems {
  GENERAL_INFO = "General Info",
  PERFORMANCE = "Performance",
  HEALTH = "Health",
  SUMMARY = "Summary"
}

export interface IMenuItemsStatuses {
  isGeneralInfo: boolean;
  isPerformance: boolean;
  isHealth: boolean;
  isSummary: boolean;
}

export enum EExamInfoTabs {
  EID = "EID",
  LISTS = "Lists",
  PPS = "PPs",
  WORKS = "Works",
  SCRATCHES = "Scratches"
}

export interface ITabsStatuses {
  isEID: boolean;
  isLists: boolean;
  isPPS: boolean;
  isWorks: boolean;
  isScratches: boolean;
}

export const checkSelectedMenuItem = (
  value: EExamInfoMenuItems
): IMenuItemsStatuses => {
  return {
    isGeneralInfo: value === EExamInfoMenuItems.GENERAL_INFO,
    isPerformance: value === EExamInfoMenuItems.PERFORMANCE,
    isHealth: value === EExamInfoMenuItems.HEALTH,
    isSummary: value === EExamInfoMenuItems.SUMMARY
  };
};

export const checkSelectedTab = (value: EExamInfoTabs): ITabsStatuses => {
  return {
    isEID: value === EExamInfoTabs.EID,
    isLists: value === EExamInfoTabs.LISTS,
    isPPS: value === EExamInfoTabs.PPS,
    isWorks: value === EExamInfoTabs.WORKS,
    isScratches: value === EExamInfoTabs.SCRATCHES
  };
};

export const insertCharToString = (
  str: string,
  sub: string,
  pos: number
): string => `${str.slice(0, pos)}${sub}${str.slice(pos)}`;
